import { useTranslation } from "react-i18next";
import { PartLookupType } from "../../../types/part-lookup.type";
import { Button } from "@weirgroup/weir-dls";
import { printPage } from "../../../utils/printPage.util";
import { PRINT_PAGE_DIV_ID, PRINT_PAGE_TITLE } from "../../../constants/bucket.contants";

interface Props {
    attachmentInfo: PartLookupType | null;
    darkMode?: boolean;
}

export const AttachmentInfoTable = (props: Props) => {
    const { t } = useTranslation();
    const { attachmentInfo, darkMode } = props;

    // Helper function to determine background color
    const getBackgroundColor = (isCategory: boolean): string => {
        if (darkMode) {
            return isCategory ? "rgb(12, 15, 18)" : "rgb(59, 67, 76)";
        }
        return "white";
    };

    // Helper function to determine text color
    const getTextColor = (isCategory: boolean): string => {
        if (darkMode) {
            return "rgb(208, 212, 216)";
        }
        return isCategory ? "gray" : "black";
    };

    // Define a reusable style object for table cells
    const getCellStyle = (isCategory: boolean) => ({
        backgroundColor: getBackgroundColor(isCategory),
        color: getTextColor(isCategory),
    });

    // Define table rows dynamically
    const tableRows = [
        { label: t("serialNumber"), value: attachmentInfo?.serial_number },
        { label: t("type"), value: attachmentInfo?.type },
        { label: t("make"), value: attachmentInfo?.make },
        { label: t("model"), value: attachmentInfo?.model },
        { label: t("class"), value: attachmentInfo?.class },
        { label: t("noseSize"), value: attachmentInfo?.nose_size },
        { label: t("pointShape"), value: attachmentInfo?.point_shape },
        { label: t("weight"), value: attachmentInfo?.weight },
        { label: t("lipWidth"), value: attachmentInfo?.lip_width },
        { label: t("partNumberPartLookup"), value: attachmentInfo?.item_number },
    ];

    return (
        <div className="attachment-information">
            <div className="table-container">
                <div className="title">
                    <p style={{ color: darkMode ? "white" : "black" }}>{t("attachmentInformation")}</p>
                    <div className="print-btn">
                        <Button
                            darkMode={darkMode}
                            label={t("print")}
                            size={"sm"}
                            variant={"primary"}
                            iconName={"Download"}
                            onClick={() => printPage(PRINT_PAGE_DIV_ID, PRINT_PAGE_TITLE)}
                        />
                    </div>
                </div>
                <table cellSpacing="0">
                    {tableRows.map((row) => (
                        <tr key={row.label}> {/* Use a unique property like `label` as the key */}
                            <td style={getCellStyle(true)} className="content category">
                                {row.label}
                            </td>
                            <td style={getCellStyle(false)} className="content">
                                {row.value}
                            </td>
                        </tr>
                    ))}
                </table>
            </div>
        </div>
    );
};